import React, { Suspense } from 'react';
import PageLoader from '@/components/shared/PageLoader';

const BicesterFrameLayout: React.FC = ({ children }: any) => {
  return (
    <div className="bicester-frame-layout">
      <Suspense fallback={<PageLoader />}>{children}</Suspense>
    </div>
  );
};

export default BicesterFrameLayout;
